export class M3PrdAdicionales{
    SKP1:string;
    ATRIBUTO:string;
    VALOR:string;
    NIVEL1:number;
    NIVEL2:number;
}